import { IFooterRow, IHeaderRow, IRow } from './IRow.interface';

export interface IPrintPreviewData {
    header: IHeaderRow[];
    rows: IRow[];
    footer?: IFooterRow;
    displayCurrency: boolean;
}
